import { EmployeeTypes } from 'types';

export default function generateQueryParams(queryParamStringConfig: EmployeeTypes.IQueryParams) {
    return Object.keys(queryParamStringConfig)
        .map((queryParam: string) => {
            const queryParamKey = queryParam.charAt(0).toUpperCase() + queryParam.slice(1);
            return `${queryParamKey}=${
                queryParamStringConfig[queryParam as keyof typeof queryParamStringConfig] as string
            }`;
        })
        .join('&');
}
